export const getCurrentSearchCep = ({ searchCep = [] } = {}) => searchCep;

export default getCurrentSearchCep;
